import {AbilityBuilder, createMongoAbility, ExtractSubjectType} from '@casl/ability';
import {User} from '../commons/models/user';
import {ManageFootballPlayer} from "../commons/models/football/admin/manage-football-player";
import {ManageFootballCompetition} from "../commons/models/football/admin/manage-football-competition";
import {ManageFootballTeam} from "../commons/models/football/admin/manage-football-team";
import {ManageFootballReferee} from "../commons/models/football/admin/manage-football-referee";
import {Stadium} from "../commons/models/stadium";
import {AppAbility, Subjects} from "./AbilityContext";
import {IAuthorizationPolicy} from "../commons/models/i-authorization-policy";
import {RolePolicySubjectEnum} from "../commons/enums/role-policy-subject.enum";
import {FootballMatchDetail} from "../commons/models/football/football-match-detail";
import { FootballOrganizer } from '../commons/models/football/football-organizer';

const subjectEntityMap: Record<RolePolicySubjectEnum, any> = {
    [RolePolicySubjectEnum.ALL]: 'all',
    [RolePolicySubjectEnum.USER]: User,
    [RolePolicySubjectEnum.PLAYER]: ManageFootballPlayer,
    [RolePolicySubjectEnum.COMPETITION]: ManageFootballCompetition,
    [RolePolicySubjectEnum.TEAM]: ManageFootballTeam,
    [RolePolicySubjectEnum.REFEREE]: ManageFootballReferee,
    [RolePolicySubjectEnum.MATCH]: FootballMatchDetail,
    [RolePolicySubjectEnum.STADIUM]: Stadium,
    [RolePolicySubjectEnum.ORGANIZER]: FootballOrganizer,
};


export function buildAbilityFor(user: User): AppAbility {
    const ability = new AbilityBuilder<AppAbility>(createMongoAbility);
    if (user) {
        for (const policy of user.policies) {
            registerPolicy(ability, policy);
        }
    }

    return ability.build({
        detectSubjectType: (item: any) =>
            item.constructor as ExtractSubjectType<Subjects>,
    });

}

function registerPolicy(
    ability: AbilityBuilder<AppAbility>,
    policy: IAuthorizationPolicy,
): void {
    const subject = resolveSubjectEntity(
        policy.subject as RolePolicySubjectEnum,
    );

    let condition = {};
    if (policy.subjectId) {
        condition = {id: policy.subjectId};
    }

    if (policy.createAction)
        ability.can('create', subject, condition);
    if (policy.readAction)
        ability.can('read', subject, condition);
    if (policy.updateAction)
        ability.can('update', subject, condition);
    if (policy.deleteAction)
        ability.can('delete', subject, condition);

    if (policy.action) {
        if (policy.isCan) {
            ability.can(policy.action, subject, condition);
        } else {
            ability.cannot(policy.action, subject, condition);
        }
    }
}

function resolveSubjectEntity(subjectKey: RolePolicySubjectEnum): any {
    return subjectEntityMap[subjectKey] ?? subjectKey;
}
